import { render } from "./FormElementButton.vue?vue&type=template&id=27cdf016"
import script from "./FormElementButton.vue?vue&type=script&lang=js"
export * from "./FormElementButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__